export function successStorySlug(title: string): string {
  return title
    .replace(/\n/g, ' ')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Default "Read the Full Story" → dedicated success-stories page with story anchor. */
export function resolveMilestoneCtaHref(href: string | undefined, title: string): string | undefined {
  const slug = successStorySlug(title);
  const raw = href?.trim();

  if (!raw) {
    return slug ? `/success-stories#${slug}` : '/success-stories';
  }

  const lower = raw.toLowerCase();
  if (lower === '#cta') {
    return '#cta';
  }

  const hashIdx = raw.indexOf('#');
  const pathPart = (hashIdx >= 0 ? raw.slice(0, hashIdx) : raw).replace(/\/+$/, '');
  const fragment = hashIdx >= 0 ? raw.slice(hashIdx + 1) : '';
  const pathLower = pathPart.toLowerCase();

  if (
    pathLower === '/success-stories' ||
    pathLower === 'success-stories' ||
    lower === '#success-stories'
  ) {
    return `/success-stories#${fragment || slug}`;
  }

  return raw;
}

export type MilestoneCtaLink =
  | { kind: 'external'; href: string }
  | { kind: 'router'; path: string; fragment?: string }
  | { kind: 'hash'; href: string };

export function parseMilestoneCtaLink(href: string): MilestoneCtaLink {
  if (/^https?:\/\//i.test(href)) {
    return { kind: 'external', href };
  }

  const hashIdx = href.indexOf('#');
  const pathPart = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
  const fragment = hashIdx >= 0 ? href.slice(hashIdx + 1) : undefined;

  if (pathPart.startsWith('/')) {
    return { kind: 'router', path: pathPart || '/', fragment };
  }

  return { kind: 'hash', href };
}
